import * as React from 'react';
import * as moment from 'moment';
import { QuantitySelectProps } from '../../components/cart/quantity-select';

const QuantitySelectView: React.StatelessComponent<QuantitySelectProps> = props => {

    function onChange(evt: React.ChangeEvent<HTMLSelectElement>) {
        const selectedValue = +evt.currentTarget.value;
        const priceTypeId = +evt.currentTarget.options[evt.currentTarget.selectedIndex].getAttribute('data-price-type');
        props.selectPriceTypeQuantity(priceTypeId, selectedValue);
    }

    const qtySelect = (
        <>
            {
                props.packagePriceTypes.map(pt => {
                    var selectName = "quantity" + pt.priceTypeId;

                    var options = Array.from(Array(pt.maxSeats + 1).keys());


                    return <div className={ `stack-xs` } key={pt.priceTypeId}>
                        <label htmlFor={selectName}>{pt.description}</label>

                        <select id={selectName}
                            value={props.selectedPriceTypeQuantities.get(pt.priceTypeId) ? props.selectedPriceTypeQuantities.get(pt.priceTypeId) : 0} onChange={(evt) => {
                                onChange(evt);
                            }}>
                            {
                                options.map(quantity =>
                                    <option key={pt.priceTypeId + "-" + quantity} data-price-type={pt.priceTypeId} value={quantity} >{quantity}</option>
                                )}
                        </select>

                    </div>
                })
            }
        </>
    );

    return (
        <>
            {qtySelect}
        </>
    );
}

export default QuantitySelectView;